/**
 * Zod schemas for Basic Comment plugin configuration (markdown content) and execution data (optional note).
 */
import { z } from "zod";
/**
 * Configuration schema for the basic comment step type.
 * Admins configure the markdown content to display.
 */
export const configSchema = z.object({
    /** Markdown content to display to the user */
    content: z.string().min(1, "Content is required"),
});
/**
 * Data schema for the basic comment step type.
 * User confirms they have read the content.
 */
export const dataSchema = z.object({
    /** Optional confirmation note from the user */
    confirmationNote: z.string().optional(),
});
/**
 * Default configuration for new comment steps.
 */
export const defaultConfig = {
    content: "Enter your comment here...",
};
//# sourceMappingURL=schema.js.map